import { Popover, Transition } from "@headlessui/react";
import { useGetStakeHolderDetailsQuery } from "../calendar-dashboard/calendar-dashboard-admin/slices/calendarDashboardAdminApiSlice";

interface Props {
  users: any;
}

const StakeHolderDisplay = ({ users }: Props) => {
  const { data: people } = useGetStakeHolderDetailsQuery(
    {
      pageNumber: 1,
      pageSize: users.length > 0 ? users.length : 1,
      sortKey: "createdat",
      sortOrder: "DESC",
      data: users
    },
    { skip: users?.length <= 0 }
  );

  const names = people?.data?.profiles
    ?.map((el: any) => el.name.fullName)
    .join(", ");
  return (
    <>
      <div className="inline-flex h-6 w-6 items-center justify-center mr-3">
        <Popover className="relative">
          <Popover.Button className="outline-none">
            <div className="flex -space-x-1.5 overflow-hidden">
              {people?.data?.profiles.map((el: any) => (
                <div
                  key={el.id}
                  className="flex justify-center items-center flex-shrink-0 h-8 w-8 rounded-full ring-1 border border-border ring-white dark:ring-border bg-bkg"
                >
                  <span className="text-sm font-medium leading-none text-secondary">
                    {el.name.firstName.charAt(0) + el.name.lastName.charAt(0)}
                  </span>
                </div>
              ))}
            </div>
          </Popover.Button>
          <Transition
            enter="transition duration-300 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-300 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Popover.Panel className="absolute z-50 left-[60px]  -translate-x-1/2 w-max max-w-[150px] overflow-hidden">
              <div className="bg-secondary text-white dark:text-black w-full text-sm text-center px-3 py-2 rounded-md flex flex-wrap gap-x-2 justify-center break-words">
                {names}
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    </>
  );
};

export default StakeHolderDisplay;
